<app-loader *ngIf="isLoading"></app-loader>
<div class="container">
  <div class = "min-vh-100 d-flex align-items-center">
    <div class="row align-items-center w-100 mx-auto"> 
      <div class="card col-md-8 mx-auto">
        <div class="card-body">
          <div class = "text-center mb-3">
            <ng-container [ngSwitch]="currentStatus">
              <img *ngSwitchCase="'APROBADA'" src = "assets/images/check_circle.svg">
              <img *ngSwitchCase="'ANULADA'" src = "assets/images/cancel.svg">
              <img *ngSwitchCase="'RECHAZADA'" src = "assets/images/cancel.svg">
              <img *ngSwitchDefault src = "assets/images/credit_card_clock.svg">
            </ng-container>
          </div>
          <h1 class = "transaction-status text-center mb-5">Transacción {{ currentStatus }}</h1>
          <h5 class="main-text checkout-title mb-3">Información de la transferencia</h5>
          <div class="row fields-row">
            <div class="col-12">
              <label class="label-checkout">Id de la transferencia</label>
              <input
                type="text"
                [value]="transactionData?.id"
                readonly
                class="form-control input-checkout"
              />
            </div>
            <div class="col-12">
              <label class="label-checkout">Fecha de pago</label>
              <input
                type="text"
                [value]="formatDate(transactionData?.finalized_at)"
                readonly
                class="form-control input-checkout"
              />
            </div>
            <div class="col-12">
              <label class="label-checkout">Método de pago</label>
              <input
                type="text"
                [value]="paymentMethod"
                readonly
                class="form-control input-checkout"
              />
            </div>
            <div class="col-12">
              <label class="label-checkout">Valor</label>
              <input
                type="text"
                [value]="value | currency"
                readonly
                class="form-control input-checkout"
              />
            </div>
            <div class="col-12">
              <label class="label-checkout">Estado</label>
              <input
                type="text"
                [value]="currentStatus"
                readonly
                class="form-control input-checkout"
              />
            </div>
            <div *ngIf="!isWebView()" class = "col-12 d-md-flex justify-content-center gap-3 buttons-container">
              <div class = "col-md-6">
                <button class = "btn-primary" (click)="redirectToMarketplace()">Seguir comprando</button>
              </div>
              <div class = "col-md-6">
                <button class = "btn-secondary" (click)="redirectToOrdersInMarketplace()">Ir a mis pedidos</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

